<template>
  <el-dialog v-loading.fullscreen="loading" :append-to-body="true" title="添加收件人" :visible="visible" width="560px"
    @close="$emit('close')">

    <el-form ref="form" :rules="rules" :model="form" label-width="140px">
      <el-form-item label="收件人姓名" :prop="`name`" :rules="rules.name">
        <el-input v-model="form.name" style="width: 200px;" maxlength="20" placeholder="请输入收件人姓名"></el-input>
      </el-form-item>
      <el-form-item label="收件人区域" :prop="`recipientArea`" :rules="rules.recipientArea">
        <el-cascader v-model="form.recipientArea" :props="{ checkStrictly: true }" :options="regionData" />
      </el-form-item>
      <el-form-item label="收件人详细地址" :prop="`address`" :rules="rules.address">
        <el-input v-model="form.address" style="width: 200px;" maxlength="100" placeholder="请输入收件人详细地址"></el-input>
      </el-form-item>
      <el-form-item label="收件人电话" :prop="`telephone`" :rules="rules.telephone">
        <el-input v-model="form.telephone" style="width: 200px;" maxlength="100" placeholder="请输入收件人电话"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">取 消</el-button>
      <el-button type="primary" @click="submit"> 确 定 </el-button>
    </span>
  </el-dialog>
</template>

<script>
// import { getDict } from '@/api/common/index'
import { regionData } from 'element-china-area-data'
import { findNode } from '@/utils/ruoyi'
import { saveOrUpdateCustom } from '@/api/system/custom'

export default {
  name: 'ProductSelect',
  props: {
    customerInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    visible: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  data: () => {
    return {
      regionData,
      loading: false,
      form: {
        telephone: null,
        name: null,
        recipientArea: null,
        address: null,
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入收件人姓名',
            trigger: ['change', 'blur']
          }
        ],
        recipientArea: [
          {
            required: true,
            message: '请选择收件人区域',
            trigger: ['change', 'blur']
          }
        ],
        telephone: [{
          required: true,
          message: '请输入收件人电话',
          trigger: ['change', 'blur']
        }, {
          pattern: /^(?:(?:\+?86)?1[3-9]\d{9}|0[1-9]\d{1,2}-?\d{7,8})$/,
          message: '请输入正确的电话格式',
          trigger: ['change', 'blur']
        }]
      }
    }
  },

  methods: {
    // 保存
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        this.loading = true
        const form = JSON.parse(JSON.stringify(this.form));
        if (form.recipientArea) {
          // 省市区转换
          const [consigneeProvinceName, consigneeCityName, consigneeCountyName] = form.recipientArea
          // 省市区转换
          const provinceName = findNode(this.regionData, consigneeProvinceName)
          const cityName = findNode(this.regionData, consigneeCityName)
          const countyName = findNode(this.regionData, consigneeCountyName)
          form.provinceName = provinceName ? provinceName.label : ''
          form.cityName = cityName ? cityName.label : ''
          form.countyName = countyName ? countyName.label : ''
          delete form.recipientArea
        }
        const params = JSON.parse(JSON.stringify(this.customerInfo))
        const { customerRecipientVoList:customerRecipientBoList } = params
        customerRecipientBoList.push(form)
        this.loading = true
        saveOrUpdateCustom({...params,customerRecipientBoList}).then(() => {
          this.$emit('close')
        }).finally(() => {
          this.loading = false
        })
      })
    },
  }
}
</script>
